import { render, staticRenderFns } from "./SwitchAdminForLbOrder.vue?vue&type=template&id=2af77462&scoped=true&"
import script from "./SwitchAdminForLbOrder.vue?vue&type=script&lang=js&"
export * from "./SwitchAdminForLbOrder.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAdminForLbOrder.vue?vue&type=style&index=0&id=2af77462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af77462",
  null
  
)

export default component.exports